import type { TurnPhase } from "../../types/game";
import type { Player } from "../../types/game";
import { useLanguage } from "../../i18n/LanguageContext";

interface Props { player: Player; phase: TurnPhase; }

export default function TurnIndicator({ player, phase }: Props) {
  const { t } = useLanguage();
  return (
    <div className="bg-slate-800/80 rounded-2xl border border-white/10 p-3 text-center">
      <div className="text-sm text-white/50 font-display mb-1">{t.board.currentTurn}</div>
      <div className="font-display font-black text-white text-lg">{player.avatarKey} {player.name}</div>
      <div className="text-sm text-white/60 mt-1 font-display">{t.phases[phase]}</div>
    </div>
  );
}
